module.exports = __webpack_public_path__ + "static/yoga-8a8706180dab570a7838415d111f758c.png";